import React from 'react';
import { Helmet } from 'react-helmet-async';

import HeroSection from '../components/HeroSection';
import AboutUsSection from '../components/AboutUsSection';
import FeatureBar from '../components/FeatureBar';
import PhotoGallery from '../components/PhotoGallery';
import OffersSection from '../components/OffersSection';
import MenuSection from '../components/MenuSection';
import ImageShowcase from '../components/ImageShowcase';
import EleganceRedefined from '../components/EleganceRedefined';
import ExperienceSection from '../components/ExperienceSection';
import TestimonialsSection from '../components/TestimonialsSection';
import ContactSection from '../components/ContactSection';
import InstagramFeed from '../components/InstagramFeed';
import FloatingChatBot from '../components/FloatingChatBot';
import FAQSection from '../components/FAQSection';
const Home = () => (
  <>
    {/* ✅ SEO & Structured Data */}
    <Helmet>
      <title>The Porch Cafe | Best Rooftop Veg Restaurant in Kota</title>
      <meta
        name="description"
        content="The Porch Cafe is Kota's premier rooftop vegetarian restaurant offering North Indian, Italian, Chinese cuisine and cozy ambiance. Perfect for family, friends, and dates."
      />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href="https://admin.theporch.in/" />

      {/* Open Graph / Facebook */}
      <meta property="og:title" content="The Porch Cafe | Best Rooftop Veg Restaurant in Kota" />
      <meta
        property="og:description"
        content="Rooftop dining in Kota with a rich vegetarian menu, warm ambiance, and Instagram-worthy decor. Visit The Porch Cafe today!"
      />
      <meta property="og:image" content="https://admin.theporch.in/logo.png" />
      <meta property="og:url" content="https://admin.theporch.in/" />
      <meta property="og:type" content="restaurant" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="The Porch Cafe | Rooftop Veg Restaurant in Kota" />
      <meta
        name="twitter:description"
        content="Enjoy great food and ambiance at Kota’s most loved rooftop vegetarian restaurant."
      />
      <meta name="twitter:image" content="https://admin.theporch.in/logo.png" />

      {/* Structured Data */}
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "Restaurant",
            "name": "The Porch Cafe & Restaurant",
            "image": "https://admin.theporch.in/logo.png",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Hotel The Pride, Talwandi",
              "addressLocality": "Kota",
              "addressRegion": "Rajasthan",
              "postalCode": "324005"
            },
            "telephone": "+91 9024283004",
            "servesCuisine": ["North Indian", "Chinese", "Italian", "Vegetarian"],
            "url": "https://admin.theporch.in/",
            "priceRange": "₹₹",
            "description": "The Porch Cafe is a vegetarian rooftop restaurant in Kota offering a unique dining experience with multi-cuisine dishes.",
            "sameAs": [
              "https://www.instagram.com/_the.porch/",
              "https://www.facebook.com/people/The-Porch-Cafe-Restaurant/100083751721732/",
              "https://www.swiggy.com/city/kota/the-porch-cafe-and-restaurant-hotel-the-pride-talwandi-rest888157",
              "https://www.zomato.com/kota/the-porch-cafe-restaurant-talwandi"
            ]
          }
        `}
      </script>
    </Helmet>

    {/* ✅ Page Sections */}
    <HeroSection />
    <AboutUsSection id="about-us" />
    <FeatureBar />
    <PhotoGallery />
    <InstagramFeed />
    <OffersSection />
    <MenuSection />
    <ImageShowcase />
    <EleganceRedefined id="services" />
    <ExperienceSection />
    <TestimonialsSection />
    <FloatingChatBot />
    <ContactSection id="contact-us" />
    <FAQSection />
  </>
);

export default Home;
